export default __webpack_public_path__ + "static/media/background.16d13642.png";